import React, { useState, useEffect } from "react";
import { Icons } from "../../constants/icon-library";

function PlatformExecuteModal({
  show,
  platform,
  item,
  authorName,
  participants,
  onClose,
  onExecute,
  isExecuting,
}) {
  const [tagsInput, setTagsInput] = useState("");
  const [assigneeId, setAssigneeId] = useState("");
  const [dueDate, setDueDate] = useState("");

  useEffect(() => {
    if (show) {
      setTagsInput("");
      setAssigneeId("");
      setDueDate("");
    }
  }, [show, item]);

  if (!show) return null;

  const availableTags = platform?.availableTags || [];
  const activeTags = tagsInput.split(",").map((t) => t.trim()).filter(Boolean);

  const toggleTag = (tag) => {
    const next = activeTags.includes(tag)
      ? activeTags.filter((t) => t !== tag)
      : [...activeTags, tag];
    setTagsInput(next.join(", "));
  };

  const handleExecuteClick = () => {
    onExecute({
      tags: activeTags,
      assigneeId: assigneeId || null,
      dueDate: dueDate || null,
    });
  };

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
      tabIndex={-1}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title d-flex align-items-center gap-2 mb-0">
              <i className="bi bi-plug-fill text-primary" />
              Execute on {platform?.platform}
            </h6>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label small fw-semibold text-body-secondary">Message</label>
              <div
                className="bg-body-secondary rounded-3 p-2"
                style={{ fontSize: 13, maxHeight: 90, overflowY: "auto" }}
              >
                {item?.text}
              </div>
              {authorName && <small className="text-body-secondary">From {authorName}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label small fw-semibold text-body-secondary">Tags</label>
              {availableTags.length > 0 ? (
                <div className="d-flex flex-wrap gap-2">
                  {availableTags.map((tag) => (
                    <button
                      key={tag}
                      type="button"
                      className={`badge border-0 ${
                        activeTags.includes(tag)
                          ? "bg-primary text-white"
                          : "bg-secondary-subtle text-secondary-emphasis"
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTag(tag)}
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              ) : (
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Comma separated tags"
                  value={tagsInput}
                  onChange={(e) => setTagsInput(e.target.value)}
                />
              )}
            </div>

            <div className="mb-3">
              <label className="form-label small fw-semibold text-body-secondary">Assignee</label>
              <select
                className="form-select form-select-sm"
                value={assigneeId}
                onChange={(e) => setAssigneeId(e.target.value)}
              >
                <option value="">Unassigned</option>
                {(participants || []).map((p) => (
                  <option key={p.uuid || p._id} value={p.uuid || p._id}>
                    {p.name || p.fullName || p.email}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-1">
              <label className="form-label small fw-semibold text-body-secondary">Due date</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onClose}
              disabled={isExecuting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-sm btn-primary d-flex align-items-center gap-1"
              onClick={handleExecuteClick}
              disabled={isExecuting}
            >
              {isExecuting ? (
                <span className="spinner-border spinner-border-sm" />
              ) : (
                <i className={`wb ${Icons("resume")}`} />
              )}
              Execute
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlatformExecuteModal;